<template>
<div>
    <button
      class="filterItem"
      v-for="tag in tags"
      :key="tag.value"
      v-on:click="clearTag(tag)"
    >
      {{tag.value.getFullYear()}}
    </button>
</div>
</template>

<script lang="ts">
import Vue from "vue";
import { GenericSearchResponseFacetsCreatedItem } from '../client/src/models/index';

export default Vue.extend({
  name: "ChosenDateTags",
  props: {
    tags: {
      type: Array as () => GenericSearchResponseFacetsCreatedItem[],
      required: true,
      default: () => []
    }
  },
  methods: {
    clearTag: function (tag: GenericSearchResponseFacetsCreatedItem) {
      this.$emit("clearTag", tag);
    }
  }
});
</script>
